export default __webpack_public_path__ + "media/39079e711f1633ee27998991ab58b5384d1d2bae681658fa80744710e64d5ee0.svg";